const deleteStatusVerificationItems = {
  toastr: 'Tipo de Servicio eliminado',
  toastr1: ' eliminado con éxito'
};

export default deleteStatusVerificationItems;
